import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import {
  Avatar,
  Select,
  Switch,
  Tabs,
  Popover,
  Button,
  Popconfirm,
} from "antd";
import images from "../../themes/appImage";
import { Table, Modal } from "antd";
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  activeMainAdminLoad,
  createSubAdminListLoad,
  createSubAdminLoad,
  deleteMainAdminLoad,
  getAccessListLoad,
  editAdminLoad
} from "../../redux/slices/setting.slice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { Navigate, useNavigate } from "react-router-dom";
import UploadAvatar from "./Avatar";
import { emptySpaceInputHandler } from "../../utils";
import { activeAdminLoad } from "../../redux/slices/admin.slice";


const handleChange = (value) => {
  console.log(`selected ${value}`);
};

//  It's for edit admin
let adminId;
const routes = {
  "Inner Circles": [
    "inner-circle-detail",
    "inner-circle-count",
    "get-inner-circle-list",
    "get-inner-circle",
    "circle-post-list",
    "remove-inner-circle",
  ],
  Reports: ["report-list", "report-data", "report-detail", "remove-post"],
};
const initialSwitchesValue = [
  {
    text: "Reports",
    access: false,
  },
  {
    text: "Inner Circles",
    access: false,
  },
];
let LIST_LIMIT = 10;
let OFFSET = 0;
let currentSortValue = -1;
let sort = "createdAt";
const userListPayload = {
  offset: 0,
  limit: 10,
  search: "",
  sort: sort,
  order: currentSortValue,
};
const numberOfRowOptionList = [
  { value: "one", label: 10 },
  { value: "two", label: 20 },
  { value: "three", label: 25 },
];
const Settings = () => {
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const userType = localStorage.getItem("adminType") === "admin";
    if (!userType) {
      navigate("/organizations");
    }
  }, []);
  const dispatch = useDispatch();
  const [modal1Open, setModal1Open] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [modal3Open, setModal3Open] = useState(false);
  const [modal40Open, setModal40Open] = useState(false);
  const [showAddAdminButton, setShowAddAdminButton] = useState(true);
  const [showAddRankButton, setShowAddRankButton] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState({}); // State for popover visibility

  const {
    getAccessList,
    createSubAdminSuccessState,
    adminUserListData,
    MainAdminActive,
    MainAdminDelete,
  } = useSelector((state) => state.setingReducer);
  const [accessSwitches, setAccessSwitches] = useState(initialSwitchesValue);

  useEffect(() => {
    dispatch(getAccessListLoad());
    dispatch(createSubAdminListLoad(userListPayload));
  }, []);

  const [search, setSearch] = useState("");

  const handleActive = (record) => {
    const data = {
      admin: record._id,
    };

    dispatch(activeMainAdminLoad(data));
    setPopoverVisible({ ...popoverVisible, [record._id]: false });
  };

  const handleDeleteClick = (id) => {
    console.log("no helo");
    const data = {
      admin: id,
    };
    dispatch(deleteMainAdminLoad(data));
    setPopoverVisible({ ...popoverVisible, [id]: false });
  };

  const columns2 = [
    {
      title: "ID",
      dataIndex: "srno",
      key: "srno",
      sorter: false,
      render: (value, item, index) => index + 1,
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div onClick={() => sortHandler("firstName")} className="sort-icons">
          <span>Full Name</span> <img src={images.arrowLeft} alt="" />
        </div>
      ),
      render: (value, item, index) => (
        <div className="organization-image-sec">
          <span>
            <img src={images.maleTable} />
          </span>
          {item.firstName} {item.lastName}
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: false,
    },
    {
      title: "Modules Assigned",
      dataIndex: "modules",
      key: "modules",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div
          onClick={() => sortHandler("assignedAccess")}
          className="sort-icons"
        >
          <span>Modules Assigned</span> <img src={images.arrowLeft} alt="" />
        </div>
      ),
      render: (value, item, index) => (
        <div className="organization-image-sec log-mood-block">
          {item.assignedAccess.map(access => (
            <p key={access._id}>{access.name.replace(/-/g, ' ').toUpperCase()}</p>
          ))}
        </div>
      ),
    },
    {
      title: "Joined Date",
      dataIndex: "date",
      key: "date",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div onClick={() => sortHandler("createdAt")} className="sort-icons">
          <span>Joined Date</span> <img src={images.arrowLeft} alt="" />
        </div>
      ),
      render: (value, item, index) => (
        <div className="organization-image-sec log-mood-block">
          {moment(item.createdAt).format("MMMM D, YYYY")}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      title: () => (
        <div onClick={() => sortHandler("isActive")} className="sort-icons">
          <span>Status</span> <img src={images.arrowLeft} alt="" />
        </div>
      ),
      render: (value, item, index) => (
        <div
          className="status-active"
          style={{ color: item.isActive ? "#2E7D32" : "red" }}
        >
          <span>{item.isActive ? "Active" : "DeActive"}</span>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "Posted",
      key: "Posted",
      render: (_, record) => {
        const contentId = `content-${record._id}`;
        const isVisible = popoverVisible[record._id] || false;

        const popoverContent = (
          <div id={contentId} className="flex flex-col w-[100px]">
            <Popconfirm
              title={`Are you sure you want to ${
                record.isActive ? "deactivate" : "activate"
              } this sub admin?`}
              onConfirm={() => handleActive(record)}
            >
              <Button type="text">
                {record.isActive ? "Deactivate" : "Activate"}
              </Button>
            </Popconfirm>
            <Popconfirm
              title="Are you sure you want to delete this sub admin?"
              onConfirm={() => handleDeleteClick(record._id)}
            >
              <Button type="text">Delete</Button>
            </Popconfirm>
            <Button
              type="text"
              onClick={() => {
                const accessListString=record?.assignedAccess?.length>0 && record?.assignedAccess?.map(item=>item?.name)||[]
                console.log(record,"MODAL_VAL")
                adminId=record._id
                setAccessSwitches([
                  {
                    text: "Reports",
                    access: accessListString.includes("report-list"),
                  },
                  {
                    text: "Inner Circles",
                    access: accessListString.includes("get-inner-circle-list"),
                  },
                ]);
                formik.setValues({
                  firstName: record.firstName,
                  lastName: record.lastName,
                  email: record.email,
                });
                setPopoverVisible({ ...popoverVisible, [record._id]: false });
                setModal40Open(true);
              }}
            >
              Edit
            </Button>
          </div>
        );

        return (
          <Popover
            content={popoverContent}
            trigger="click"
            visible={isVisible}
            onVisibleChange={(visible) =>
              setPopoverVisible({ ...popoverVisible, [record._id]: visible })
            }
            placement="topLeft"
          >
            <div className=" action-dots-iocn">
              <span>
                <img src={images.horizontalDots} alt="dots" />
              </span>
            </div>
          </Popover>
        );
      },
    },
  ];

  // Add Admin

  // Switches

  const accessHandler = (e, index) => {
    const clone = [...accessSwitches];
    clone[index].access = e;
    setAccessSwitches(clone);
  };

  // F O R M I K  F O R  -- A D D  N E W  O R G A N I Z A T I O N  M O D AL

  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
    validationSchema,

    onSubmit: (values, { resetForm }) => {
      const haveAccess = accessSwitches
        .filter((item) => item.access)
        .map((item) => item.text);
      const accessRoutes = haveAccess.map((item) => routes[item]).flat();
      const accessIds = getAccessList
        .filter((item) => accessRoutes.includes(item.name))
        .map((item) => item._id);

      const payload = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        access: accessIds,
        admin:adminId
      };
      if(adminId){
        dispatch(editAdminLoad(payload));
        setModal40Open(false);
      }else{
          dispatch(createSubAdminLoad(payload));

      }
    },
  });

  const resetFormik = () => {
    const newValues = {
      firstName: "",
      lastName: "",
      email: "",
    };
    formik.setValues(newValues);

    const newTouched = {
      firstName: false,
      lastName: false,
      email: false,
    };
    formik.setTouched(newTouched);
  };

  useEffect(() => {
    if (createSubAdminSuccessState || MainAdminActive || MainAdminDelete) {
      console.log("first111");
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      adminId=undefined
      dispatch(createSubAdminListLoad(data));
      setModal2Open(false);
    }
  }, [createSubAdminSuccessState, MainAdminActive, MainAdminDelete]);

  // P A G I N A T I O N

  // --S T A T E--
  const START = useMemo(() => OFFSET + 1, [adminUserListData.list]);
  const TOTAL_LIST_ITEMS = useMemo(
    () => adminUserListData.pagination?.totalCount,
    [adminUserListData.list]
  );
  const END = useMemo(
    () => Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS),
    [adminUserListData.list]
  );
  const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS;

  // --A C T I O N S--

  const paginationHandler = useCallback(
    (type) => {
      if (type === "pre") {
        OFFSET = OFFSET - LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: sort,
          order: currentSortValue,
        };
        dispatch(createSubAdminListLoad(data));
      } else {
        OFFSET = OFFSET + LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: "createdAt",
          order: -1,
        };
        dispatch(createSubAdminListLoad(data));
      }
    },
    [adminUserListData.list]
  );

  const numberOfRowHandler = useCallback(
    (ddateStringate, dataObj) => {
      LIST_LIMIT = dataObj.label;
      OFFSET = 0;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      dispatch(createSubAdminListLoad(data));
    },
    [adminUserListData.list]
  );

  const searchHandler = useCallback(
    (e) => {
      if (emptySpaceInputHandler(e) || e.target.value.length == "") {
        LIST_LIMIT = 10;
        OFFSET = 0;
        setSearch(emptySpaceInputHandler(e));
        const data = {
          offset: 0,
          limit: 10,
          search: emptySpaceInputHandler(e).trim(),
          sort: "",
          order: -1,
        };
        debounce(() => dispatch(createSubAdminListLoad(data)));
      }
    },
    [adminUserListData.list]
  );

  const sortHandler = useCallback(
    (sort) => {
      currentSortValue = currentSortValue == -1 ? 1 : -1;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      dispatch(createSubAdminListLoad(data));
    },
    [adminUserListData.list]
  );

  return (
    <div className="overflow-x-auto">
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Settings</h1>
          </div>
          <div className="add-new-button">
            {showAddAdminButton && (
              <button
                onClick={() => {
                  setAccessSwitches((prev) =>
                    prev.map((item) => ({ ...item, access: false }))
                  );
                  resetFormik();
                  setModal2Open(true);
                }}
              >
                Add Admin
              </button>
            )}
            {showAddRankButton && (
              <button
                onClick={() => {
                  setModal3Open(true);
                }}
              >
                Add New Rank
              </button>
            )}
          </div>
        </div>

        <section>
          <div className="slider-section manage-table-data">
            <div className="slider-tab-div setting-page-tab">
              <div className="tab-bar">
                <Tabs
                  onChange={(e) => {
                    if (e === "2") {
                      setShowAddAdminButton(true);
                      setShowAddRankButton(false);
                    } else if (e === "3") {
                      setShowAddAdminButton(false);
                      setShowAddRankButton(true);
                    } else {
                      setShowAddAdminButton(false);
                      setShowAddRankButton(false);
                    }
                  }}
                >
                  <Tabs.TabPane tab="Admins" key="2">
                    <div className="setting-page-section ">
                      <div class="bg-gradient-primary  bott-border">
                        <input
                          type="text"
                          value={search}
                          onChange={searchHandler}
                          className="iocn-search   search-bar"
                          placeholder="Search Admin"
                        />
                      </div>

                      <div className="">
                        <Table
                          dataSource={adminUserListData.list}
                          columns={columns2}
                          showSorterTooltip={false}
                          pagination={{
                            current: 0,
                            pageSize: 0,
                            total: TOTAL_LIST_ITEMS,
                          }}
                        />

                        {TOTAL_LIST_ITEMS > 10 && (
                          <div className="footer-section">
                            <div className="foot-main-div">
                              <div className="rows">
                                <div className="row-per-page">
                                  <p>Rows per page</p>
                                </div>

                                <div className="top-checkbox fot-select">
                                  <Select
                                    defaultValue={LIST_LIMIT}
                                    onChange={numberOfRowHandler}
                                    options={numberOfRowOptionList}
                                  />
                                </div>
                              </div>

                              <div className="page-count">
                                <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                              </div>

                              <div className="back-and-next">
                                {/* <span><img src={images.back} alt="back" /></span> */}
                                <span
                                  onClick={() =>
                                    OFFSET !== 0 && paginationHandler("pre")
                                  }
                                >
                                  <img
                                    src={
                                      OFFSET == 0
                                        ? images.per
                                        : images.paginationDimLeft
                                    }
                                    style={{ tintColor: "red" }}
                                    alt="back"
                                  />
                                </span>
                                <span
                                  onClick={() =>
                                    canCallNextData && paginationHandler("next")
                                  }
                                >
                                  <img
                                    src={
                                      canCallNextData == false
                                        ? images.paginationDimRight
                                        : images.new
                                    }
                                    alt="back"
                                  />
                                </span>
                                {/* <span><img src={images.next} alt="back" /></span> */}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tabs.TabPane>

                  <Tabs.TabPane tab="Avatars" key="4">
                    <UploadAvatar />
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal2Open}
        closable={true}
        onCancel={() => setModal2Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Add Admin</h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="who-five">
                <div className="date-and-time ">
                  <div className="form-group">
                    <label>{appconstant.firstName}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Emotion Title "
                      name="firstName"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label>{appconstant.lastName}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Emotion Title"
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="form-group">
                  <label>{appconstant.email}</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-500 text-xs mt-1 font-normal">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </div>

                <div className="app-features">
                  <h1>Assign Modules</h1>
                  <div className="enable-btn">
                    {accessSwitches.map((item, index) => (
                      <div className="switch-btn">
                        <Switch
                          checked={item.access}
                          onChange={(e) => accessHandler(e, index)}
                        />
                        <p>{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="click-to-upload">
              <div className="create-inner-circle-btn less-margin">
                <button type="submit">Add Admin</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal40Open}
        closable={true}
        onCancel={() => setModal40Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1> Edit Admin</h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="who-five">
                <div className="date-and-time ">
                  <div className="form-group">
                    <label>{appconstant.firstName}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Emotion Title "
                      name="firstName"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label>{appconstant.lastName}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Emotion Title"
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="form-group">
                  <label>{appconstant.email}</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-500 text-xs mt-1 font-normal">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </div>

                <div className="app-features">
                  <h1>Assign Modules</h1>
                  <div className="enable-btn">
                    {accessSwitches.map((item, index) => (
                      <div className="switch-btn">
                        <Switch
                          checked={item.access}
                          onChange={(e) => accessHandler(e, index)}
                        />
                        <p>{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="click-to-upload">
              <div className="create-inner-circle-btn less-margin">
                <button type="submit">Update</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};
export default Settings;
